"use client";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState } from "react";
import Next from "../../../public/homePage/next.svg";
import Prev from "../../../public/homePage/prev.svg";
import Link from "next/link";

const AdvanedAnalytics = (props: any) => {
  const { activeNav, initialScroll } = props;
  const [clickedArrow, setClickedArrow] = useState("");

  const SampleNextArrow = (props: any) => {
    const { className, style, onClick, clickedArrow } = props;

    return (
      <Next
        className={
          className +
          ` productivity-next ${
            clickedArrow === "right" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("right");
          onClick();
        }}
      />
    );
  };

  const SamplePrevArrow = (props: any) => {
    const { className, style, onClick, clickedArrow } = props;
    return (
      <Prev
        className={
          className +
          ` productivity-prev ${
            clickedArrow === "left" ? "carousel-btn-active" : ""
          }`
        }
        onClick={() => {
          setClickedArrow("left");

          onClick();
        }}
      />
    );
  };

  const settings = {
    initialSlide: initialScroll,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
    ],
    nextArrow: <SampleNextArrow clickedArrow={clickedArrow} />,
    prevArrow: <SamplePrevArrow clickedArrow={clickedArrow} />,
  };
  const navLinks = [
    {
      name: "static",
      label: "Statistical & Hypothesis Testing",
      url: "/services/advanced-analytics/statistical-testing",
    },
    {
      name: "regression",
      label: "Regression (Key Driver)",
      url: "/services/advanced-analytics/regression",
    },
    {
      name: "customer",
      label: "Customer Segmentation",
      url: "/services/advanced-analytics/customer-segment",
    },
    {
      name: "choice",
      label: "Choice models: Conjoint and Maxdiff",
      url: "/services/advanced-analytics/choice-modelss",
    },
    {
      name: "cluster",
      label: "Cluster Analysis",
      url: "/services/advanced-analytics/cluster-analysis",
    },
    {
      name: "principal",
      label: "Principal Component PCA & Factor Analysis",
      url: "/services/advanced-analytics/principal-component",
    },
    {
      name: "perceptual",
      label: "Perceptual Maps",
      url: "/services/advanced-analytics/perceptual-maps",
    },
  ];
  return (
    <Slider {...settings}>
      {navLinks.map((navLink, index) => {
        return (
          <div key={index} className="data-collection-nav px-1">
            <Link
              className={`nav-item ${
                activeNav === navLink.name ? "collection-nav-active" : ""
              }`}
              href={navLink.url}>
              {navLink.label}
            </Link>
          </div>
        );
      })}
    </Slider>
  );
};

export default AdvanedAnalytics;
